import { stringMatchWithSearch } from '../../../utils/globals/search'
import { Category } from '../../../utils/reducers/products/categories'

export const createThreeBySearch = (category: Category, search: string) => {
    if (!category) {
        return []
    }
    let result: Category[] | null = null
    if (stringMatchWithSearch(search, category['CategoryLangs.name'])) {
        result = [{...category, childs: []}]
    }
    if (category.childs) {
        for (const child of category.childs) {
            const childResult = createThreeBySearch(child, search)
            if (childResult) {
                if (!result) {
                    result = [{ ...category, childs: [] }]
                }
                result[0].childs?.push({...childResult[0]})
            }
        }
    }
    return result
}